import {ICamsPhoto} from "@/modules/Car/interfaces/cams-photo.interface";

export namespace IAppMediaPopup {
  export interface IPayload {
    files: IMediaFile[];
    title?: string;
    mediaInfo?: IMediaInfo;
    fileErrorText?: string;

    parentList?: {
      name: string;
      currentIndex: number;
      total: number;
    }
  }

  export interface IMediaFile {
    src: string;
    id?: number;
    cameraType?: ICamsPhoto.CameraType;
    photoInfo?: IMediaFileInfo[];
    type?: MediaType;
  }

  export interface IMediaFileInfo {
    label: string;
    prop: string;
    value: string;
    icon?: string;
    class?: string;
  }

  export interface IMediaInfo {
    carNumber: string;
    props: IMediaInfoProp[];
  }

  export interface IMediaInfoProp {
    cells: IMediaInfoCell[];
  }

  export interface IMediaInfoCell {
    label: string;
    value: string;
  }

  export enum MediaPopupSourceCall {
    ReportMovements = 'reportMovements',
    ReportEvents = 'reportEvents',
    CarPopupMovements = 'carPopupMovements',
    CarPopupCameras = 'carPopupCameras',
    BarriersLogHistory = 'barriersLogHistory',
  }

  export enum MediaType {
    Image = 'image',
  }

  export function PrepareFiles() {

  }

  export enum EmitterEvents {
    ToggleEntityTo = 'media-popup:toggle-entity-to-from-',
  }
}